<template>
    <nav>

        <v-snackbar v-if="user" v-model="addedCustomerSnackbar" :timeout="4000" top>
            <span>Awesome! Added a new customer</span>
            <v-btn flat color="white" @click="addedCustomerSnackbar=false">close</v-btn>
        </v-snackbar>

        <v-toolbar flat app>
            <v-toolbar-side-icon v-if="user" class="grey--text" @click="drawer=!drawer"></v-toolbar-side-icon>
            <v-toolbar-title class="text-uppercase grey--text">
                <span class="font-weight-light">Booksmart</span>
                <span>Beta</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>

            <!-- dropdown menu -->
            <!-- <v-menu v-if="user" offset-y>
                <v-btn flat slot="activator" color="grey">
                    <v-icon left>expand_more</v-icon>
                    <span>menu</span>
                </v-btn>
                <v-list>
                    <v-list-tile v-for="link in links" :key="link.text" router :to="link.route">
                        <v-list-tile-title>{{link.text}}</v-list-tile-title>
                    </v-list-tile>
                </v-list>
            </v-menu> -->

            <v-btn v-if="!user" @click="signup" flat color="grey">
                <span>Sign up</span>
                <!-- <v-icon right>exit_to_app</v-icon> -->
            </v-btn>
            <v-btn v-if="!user" @click="signin" flat color="grey">
                <span>Sign in</span>
                <!-- <v-icon right>exit_to_app</v-icon> -->
            </v-btn>
            <v-btn v-if="user" flat color="grey" @click="signout">
                <span>Sign out</span>
                <v-icon right>exit_to_app</v-icon>
            </v-btn>
        </v-toolbar>
        <v-navigation-drawer v-if="user" v-model="drawer" app class="primary">
            <v-layout column align-center>
                <v-flex class="mt-5">
                    <v-avatar size= "100" color="grey">
                        <span class="white--text display-1 font-weight-black">T</span>
                    </v-avatar>
                    <p class="white--text subheading mt-1 text-xs-center">{{ user.email }}</p>
                </v-flex>
                <v-flex class="mt-4 mb-3">
                    <Popup @customerAdded="addedCustomerSnackbar=true"/>
                </v-flex>
            </v-layout>
            <v-list>
                <v-list-tile v-for="link in links" :key="link.text" router :to="link.route">
                    <v-list-tile-action>
                        <v-icon class="white--text">{{link.icon}}</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile class="white--text">{{link.text}}</v-list-tile>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
        </v-navigation-drawer>
    </nav>
</template>

<script>
import Popup from './Popup'
import firebase from 'firebase/app'
require('firebase/auth')

export default {
    components: { Popup},
    data() {
        return {
            drawer: false,
            links: [
                { icon: 'dashboard', text: 'Dashboard', route: '/' },
                { icon: 'folder', text: 'My Projects', route: '/projects' },
                { icon: 'person', text: 'Customers', route: '/customers' },
            ],
            addedCustomerSnackbar: false,
            user: null
        }
    },
    methods: {
        signout() {
            firebase.auth().signOut()
            this.$router.push({name: 'login'})
        },
        signup() {
            this.$router.push({name: 'signup'})
        },
        signin() {
            this.$router.push({name: 'login'})
        }
    },
    created() {
        firebase.auth().onAuthStateChanged((user) => {
            if(user) {
                this.user = user
            } else {
                this.user = null
            }
        })
    }
}
</script>
